import React from "react"
import Fade from "react-reveal/Fade"

import {
  sectionHeading,
  sectionHeadingOrphan,
} from "./sectionHeading.module.sass"

const SectionHeading = ({ orphan, children }) => {
  return (
    <Fade>
      <div className={orphan ? sectionHeadingOrphan : sectionHeading}>
        {children}
      </div>
    </Fade>
  )
}

export default SectionHeading
